module.exports = __webpack_public_path__ + "media/scenario_menu_button.0dc23890.mp3";